var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Magnifier = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 941.25 941.22", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M589.25 704a352.08 352.08 0 0 1-137-676.32 352.08 352.08 0 0 1 274 648.64 349.74 349.74 0 0 1-137 27.68zm0-640a288 288 0 0 0-203.64 491.65 288 288 0 0 0 407.29-407.3A286.13 286.13 0 0 0 589.25 64z" }),
            React.createElement("path", { className: "cls-1", d: "M813.25 384a32 32 0 0 1-32-32A190.75 190.75 0 0 0 725 216.24 32 32 0 0 1 770.27 171a254.29 254.29 0 0 1 75 181 32 32 0 0 1-32.02 32zM77.25 941.22a77.23 77.23 0 0 1-54.62-131.85l192-192a77.25 77.25 0 1 1 109.25 109.26l-192 192a77 77 0 0 1-54.63 22.59zm182.63-278.59l-192 192a13.25 13.25 0 0 0 18.75 18.74l192-192a13.25 13.25 0 1 0-18.75-18.74z" }))))); };
export default Magnifier;
//# sourceMappingURL=Magnifier.js.map